module.exports = __webpack_public_path__ + "img/icons_35.302e3feb.svg";